import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ToggleNotificationPreferenceResponse } from '@core-http';
import { NotificationsPreferencesService } from '@notifications/infra';

export class ToggleNotificationPreferenceCommandHandler {
  private readonly service: NotificationsPreferencesService = inject(NotificationsPreferencesService);

  toggle(category: string, enabled: boolean): Observable<boolean> {
    return this.service
      .togglePreference({ category }, { enabled })
      .pipe(map((response: ToggleNotificationPreferenceResponse) => response.enabled));
  }
}
